// extracted by mini-css-extract-plugin
export var searchHeader = "_8g-0";
export var searchHeaderDark = "_8g-1";